'use client';

import parse from 'html-react-parser';
import { useSearchParams } from 'next/navigation';
import React, { useMemo } from 'react';

const isThirdPartyDisabled = (
  searchParams: ReturnType<typeof useSearchParams>,
) => {
  return searchParams?.get('disableThirdParty') === 'true';
};

export const ThirdPartyNoScript = ({
  thirdPartyNoScriptContent,
}: {
  thirdPartyNoScriptContent?: string;
}) => {
  const searchParams = useSearchParams();
  const disableThirdParty = isThirdPartyDisabled(searchParams);

  const parsed = useMemo(() => {
    if (!thirdPartyNoScriptContent?.trim()) return null;

    return parse(thirdPartyNoScriptContent.trim(), { trim: true });
  }, [thirdPartyNoScriptContent]);

  if (disableThirdParty || !parsed) return null;

  return <React.Fragment>{parsed}</React.Fragment>;
};
